import React from "react";

const Footer = () => {
  return (
    <div className="d-flex justify-content-center align-items-center p-2 text-white bg-dark">
      <h5>Developed by Utsab Adhikari</h5>
    </div>
  );
};

export default Footer;
